import { StyleSheet } from 'react-native'
import { Dialog, Portal, Text } from 'react-native-paper'
import { useDismissOnEscape } from '@/hooks/useDismissOnEscape'
import { Button } from '@/ui/Button'

interface DeleteJobDialogProps {
    visible: boolean
    jobName: string
    hasTimeEntries: boolean
    onDismiss: () => void
    onConfirm: () => void
    isDeleting: boolean
    errorMessage?: string | null
}

export function DeleteJobDialog({
    visible,
    jobName,
    hasTimeEntries,
    onDismiss,
    onConfirm,
    isDeleting,
    errorMessage,
}: DeleteJobDialogProps) {
    useDismissOnEscape(visible, onDismiss)

    return (
        <Portal>
            <Dialog visible={visible} onDismiss={onDismiss}>
                <Dialog.Title>Delete Job</Dialog.Title>
                <Dialog.Content>
                    {hasTimeEntries ? (
                        <Text style={styles.message}>
                            The job "{jobName}" cannot be deleted because it has time entries
                            associated with it. Remove all time entries first before deleting this
                            job.
                        </Text>
                    ) : (
                        <Text style={styles.message}>
                            Are you sure you want to delete the job "{jobName}"? This action cannot
                            be undone.
                        </Text>
                    )}
                    {errorMessage ? <Text style={styles.error}>{errorMessage}</Text> : null}
                </Dialog.Content>
                <Dialog.Actions>
                    {hasTimeEntries ? (
                        <Button title="OK" onPress={onDismiss} />
                    ) : (
                        <>
                            <Button title="Cancel" onPress={onDismiss} disabled={isDeleting} />
                            <Button
                                title="Delete"
                                onPress={onConfirm}
                                loading={isDeleting}
                                disabled={isDeleting}
                            />
                        </>
                    )}
                </Dialog.Actions>
            </Dialog>
        </Portal>
    )
}

const styles = StyleSheet.create({
    message: {
        marginBottom: 8,
    },
    error: {
        marginTop: 8,
        color: '#d32f2f',
    },
})
